var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "sidebar-minimizer",
      attrs: { type: "button" },
      on: {
        click: function ($event) {
          return _vm.onClick()
        },
      },
    },
    [
      _c("span", { staticClass: "sidebar-minimizer__text" }, [
        _vm._v(_vm._s(_vm.text)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }